import { IS_PROD } from '../../../../utils/constants'
import { ICvrAddress, ICvrLabelOptions, ICvrOption, TCvrLookupVariant } from './types'

export function formatAddress(address: ICvrAddress): string {
  const { roadName, number, zipCode, postalArea } = address
  return `${roadName} ${number}, ${zipCode} ${postalArea}` //TODO: OPTIONAL: Format the text to be more human friendly
}

export function getLabelOptions(option: ICvrOption, labelOptions: ICvrLabelOptions): string {
  let string = ``

  type Keys = keyof ICvrLabelOptions

  Object.keys(labelOptions).forEach(options => {
    const key = options as Keys
    if (labelOptions[key] && option[key]) {
      switch (key) {
        case 'name':
          string += `, ${option[key]}`
          break
        case 'cvrNumber':
          string += `, CVR: ${option[key]}`
          break
        case 'address':
          string += `, ${formatAddress(option[key])}`
          break
        case 'pNumber':
          string += `, P-nummer: ${option[key]}`
          break
      }
    }
  })
  if (string.charAt(0) === ',') {
    return string.slice(1)
  }
  return string
}

export function getOptionLabel(
  option: ICvrOption,
  variant: TCvrLookupVariant,
  labelOptions?: ICvrLabelOptions,
): string {
  if (typeof option !== 'object') return option
  return variant === 'lite'
    ? option.name
    : labelOptions
      ? getLabelOptions(option, labelOptions)
      : `${option.name}, CVR: ${option.cvrNumber}${option.pNumber ? `, P-nummer: ${option.pNumber}` : ``}`.trim()
}

export function getOptionSelected(option: ICvrOption, value: ICvrOption): boolean {
  if (typeof option !== 'object') {
    option === value
  }
  return option.cvrNumber === value.cvrNumber
}

export function modelData(data: ICvrOption[]): ICvrOption[] {
  return data.slice(0, 26).sort()
}

export function urlBuilder(searchTerm: string, searchMaxSize: string, variant: TCvrLookupVariant): string {
  const cvrUrl = IS_PROD ? 'https://tdc.dk/' : '/'
  return `${cvrUrl}api/cvr/checkcvrlite?term=${encodeURIComponent(searchTerm)}&searchMaxSize=${searchMaxSize}`
}
